<template>
  <div v-if="claims && claims.length">
    <v-card-title class="py-0">
      <h2 class="text-h2 mt-10 mb-7">
        {{ $t("drivingPanelStrings.title") }}
      </h2>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="claims"
        :items-per-page="-1"
        hide-default-footer
      >
        <template
          #item.date="{ item }"
        >
          {{ m(item.date, $t("commonStrings.dateDisplayFormat")) }}
        </template>
        <template
          #item.claimTypeId="{ item }"
        >
          {{ $t(`enums.vehicleTypes.${item.claimTypeId}`) }}
        </template>

        <template #item.amount="{ item }">
          {{ toMoney(item.amount) }}
        </template>

        <template #item.passengers="{ item }">
          <passenger-tooltip :claim="item" />
        </template>

        <template #item.payingOrgs="{ item }">
          <v-tooltip location="top">
            <template #activator="{ props }">
              <span v-bind="props">
                <paying-orgs-label :paying-orgs="item.payingOrgs" />
              </span>
            </template>
            <ul>
              <li
                v-for="(name, index) in getNames(item.payingOrgs)"
                :key="index"
              >
                {{ name }}
              </li>
            </ul>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </div>
</template>

<script>
import readonlyPanel from "@/mixins/readonlyPanel";
import PayingOrgsLabel from "@/views/applications/components/PayingOrgsLabel";
import PassengerTooltip from "@/views/applications/components/TripPassengersWithTooltip";
import { m } from '@/plugins/moment';

export default {
  name: "TripsPanel",
  components: {
    PayingOrgsLabel,
    PassengerTooltip
  },
  mixins: [readonlyPanel],
  props: {
    claims: {
      type: Array,
      required: true
    }
  },
  setup() {
    return { m };
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("drivingPanelStrings.tableHeaders.date"),
          align: "left",
          sortable: false,
          value: "date"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.vehicleType"),
          align: "left",
          sortable: false,
          value: "claimTypeId"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.payingOrgs"),
          align: "left",
          sortable: false,
          value: "payingOrgs"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.from"),
          align: "left",
          sortable: false,
          value: "from"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.to"),
          align: "left",
          sortable: false,
          value: "to"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.tripLength"),
          align: "right",
          sortable: false,
          value: "kilometers"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.passengers"),
          align: "right",
          sortable: false,
          value: "passengers"
        },

        {
          text: this.$t("drivingPanelStrings.tableHeaders.amount"),
          align: "right",
          sortable: false,
          value: "amount"
        }
      ]
    };
  }
};
</script>
